export default [
  {
    id: 1,
    name: "Percentage",
    value: "percentage",
  },
  {
    id: 2,
    name: "Fixed Amount",
    value: "fixed_amount",
  },
]